module.exports = __webpack_public_path__ + "media/src/public/img/android-chrome-512x512-c7c49bb8c3a0c62d0a77667b7e614c83.png";